export enum ConversionStatusCode {
  NewProject = 1,
  OnGoing = 2,
  EndReported = 3,
}
